module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-tree-container"
  }, [_c('el-row', {
    staticClass: "content-bottom-padded",
    staticStyle: {
      "padding-top": "15px",
      "margin-left": "20px"
    }
  }, [_c('el-col', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus",
      "size": "mini",
      "disabled": _vm.isDisable
    },
    on: {
      "click": _vm.updateCategory
    }
  }, [_vm._v("保存主类目")])], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tree-background block"
  }, [_c('el-tree', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.categoryList,
      "default-expand-all": "",
      "expand-on-click-node": false
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;
        var data = ref.data;

        return _c('ul', {
          staticClass: "custom-tree-node"
        }, [_c('li', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (data.category_name),
            expression: "data.category_name"
          }],
          attrs: {
            "placeholder": "名称"
          },
          domProps: {
            "value": (data.category_name)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(data, "category_name", $event.target.value)
            }
          }
        }), _vm._v(" "), (data.category_level == 1 || data.category_level == 2) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.append(data.children, data.category_level, data)
            }
          }
        }, [_vm._v("新增子类目")]) : _vm._e()], 1), _vm._v(" "), _c('span', [_c('span', {
          staticStyle: {
            "padding-right": "100px"
          }
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (data.sort),
            expression: "data.sort"
          }],
          staticStyle: {
            "width": "50px"
          },
          attrs: {
            "placeholder": "排序"
          },
          domProps: {
            "value": (data.sort)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(data, "sort", $event.target.value)
            }
          }
        })]), _vm._v(" "), (data.created) ? _c('span', {
          style: (data.category_level == 3 ? 'padding-right:100px' : 'padding-right:234px')
        }, [_vm._v(_vm._s(_vm._f("datetime")(data.created)))]) : _vm._e(), _vm._v(" "), (data.category_level == 3 || data.category_level == 2) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDialogAttr(data, 'item_params', node)
            }
          }
        }, [_vm._v("关联参数")]) : _vm._e(), _vm._v(" "), (data.category_level == 3 || data.category_level == 2) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDialogAttr(data, 'item_spec', node)
            }
          }
        }, [_vm._v("关联规格")]) : _vm._e(), _vm._v(" "), _c('router-link', {
          attrs: {
            "to": {
              path: _vm.matchInternalRoute('goodsphysical'),
              query: {
                main_cat_id: data.category_id
              }
            }
          }
        }, [_vm._v(" 查看商品 ")])], 1)])
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "add-category"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.append(_vm.categoryList)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("增加顶级类目")])])], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": (_vm.currentAttrType == 'item_params') ? '关联参数' : '关联规格',
      "visible": _vm.relAttrvisible,
      "before-close": _vm.handleCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.relAttrvisible = $event
      }
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "关联说明",
      "type": "info",
      "description": "类目最多关联20个商品参数和5个规格，并且只能关联一个图片属性规格",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dialogLoading),
      expression: "dialogLoading"
    }],
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.goodsAttr,
      "tooltip-effect": "dark"
    },
    on: {
      "select": _vm.handleSelectionChange,
      "select-all": _vm.selectAll
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return _vm._l((props.row.attribute_values.list), function(item, index) {
          return _c('span', {
            key: index,
            staticClass: "sku-value"
          }, [_c('el-tag', {
            attrs: {
              "type": "info"
            }
          }, [_vm._v(" " + _vm._s(item.attribute_value))])], 1)
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "attribute_name",
      "label": "全部"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.attribute_memo) ? _c('span', [_vm._v(_vm._s(props.row.attribute_name) + "【" + _vm._s(props.row.attribute_memo) + "】")]) : _c('span', [_vm._v(_vm._s(props.row.attribute_name))]), _vm._v(" "), (_vm.currentAttrType == 'item_spec' && props.row.is_image == 'true') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "type": "success"
          }
        }, [_vm._v("图片")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.attrParams.page,
      "page-sizes": [10, 20, 50],
      "total": this.goodsAttrTotal,
      "page-size": _vm.attrParams.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.attrParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.attrParams, "page", $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.checkGoodsAttr
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "attribute_name",
      "label": '已选择(' + this.checkGoodsAttr.length + ')'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.attribute_memo) ? _c('span', [_vm._v(_vm._s(props.row.attribute_name) + "【" + _vm._s(props.row.attribute_memo) + "】")]) : _c('span', [_vm._v(_vm._s(props.row.attribute_name))]), _vm._v(" "), (_vm.currentAttrType == 'item_spec' && props.row.is_image == 'true') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "type": "success"
          }
        }, [_vm._v("图片")]) : _vm._e()]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveCategoryAttr
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('ul', {
    staticClass: "custom-tree-node-title"
  }, [_c('li', [_vm._v("类目名称")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3d3a1848", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d3a1848"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/goods/maincategory.vue
// module id = 2644
// module chunks = 0